import { IApplicationState } from '../../types/redux';

export const consultantChatIdSelector = (state: IApplicationState) => state.consultantCianChat.chatId;
